import type { SVGProps } from 'react';

export const Unarchive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="13.2px"
    role="img"
    viewBox="0 0 15.5 13.2"
    width="15.5px"
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{'unarchive'}</title>
    <g>
      <path
        d="M10.5,3.8c0.3,0.3,0.6,0.6,0.9,0.9h3.3v7.3c0,0.2-0.2,0.4-0.4,0.4H4c-0.2,0-0.4-0.2-0.4-0.4
          v-1.2L2.7,9.8v2.1c0,0.7,0.6,1.3,1.3,1.3h10.3c0.7,0,1.3-0.6,1.3-1.3V4.6l0,0V3.8H10.5z"
      />
    </g>
    <path
      d="M11.7,10.5c-1.5-2.1-3.5-3.2-6.4-3.3L5.2,9.4c0,0.1,0,0.3-0.2,0.3s-0.3,0-0.4-0.1L0.1,5
      C0,5,0,4.9,0,4.8s0.1-0.2,0.2-0.3l4.7-4.4C4.9,0,5,0,5.2,0c0.1,0.1,0.2,0.2,0.2,0.3L5.4,2.6c3.8,0.7,6.3,3.4,7,7.5
      c0,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.2,0.1-0.2,0C11.8,10.6,11.7,10.5,11.7,10.5z M0.9,4.8l3.6,3.8l0-1.8c0-0.2,0.2-0.4,0.4-0.4
      c2.8,0.1,4.8,0.8,6.3,2.4C10.5,6.4,8.7,4,5,3.3C4.7,3.3,4.6,3.1,4.6,2.9l0-1.7L0.9,4.8z"
    />
  </svg>
);
